(() => {
  if (customElements.get('venora-benefits-bar')) return;

  class VenoraBenefitsBar extends HTMLElement {
    connectedCallback() {
      this.pauseButton = this.querySelector('.venora-benefits__pause');
      this.dataset.ready = 'true';
      if (!this.pauseButton) return;
      this.onPause = this.onPause || (() => {
        this.dataset.paused = String(this.dataset.paused !== 'true');
        this.syncPauseButton();
      });
      this.pauseButton.addEventListener('click', this.onPause);
      this.syncPauseButton();
      this.pauseButton.hidden = false;
    }

    disconnectedCallback() {
      if (this.pauseButton) this.pauseButton.removeEventListener('click', this.onPause);
    }

    syncPauseButton() {
      const paused = this.dataset.paused === 'true';
      const label = paused ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-pressed', String(paused));
      this.pauseButton.setAttribute('aria-label', label);
      this.pauseButton.title = label;
    }
  }

  customElements.define('venora-benefits-bar', VenoraBenefitsBar);
})();
